import { Hero } from "../hero/hero";

// @TODO: hero, container, and slide are all similar (with container being more flexible)
// think through how all of these modules could use the same layout module to avoid duplicitive code
export { Hero as Slide };
